var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-collapseable',[_c('record-next-contact',{attrs:{"record":_vm.record,"show-next-month":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }